































import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";
import {addDefaultValuesToStore, killNotRelevantCriteria} from "@/shared/scripts/ValidateData";

export default Vue.extend({
    name: "PropertySubtype",
    components: {
        iwInputSelect: iwInputSelect,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.subtype",
            inputName: "property-subtype",
            specificId: uuidv4() as string
        };
    },
    computed: {
        propertySubtype: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        propertyType: function(): string|null {
            return this.$store.getters["FormModule/getValue"]("property.type");
        },
        currentSubtypes: function(): Array<Record<string, unknown>> {
            switch (this.propertyType) {
            case "HOUSE":
                return [
                    {
                        "label": this.$t("house"),
                        "value": "HOUSE"
                    },
                    {
                        "label": this.$t("bungalow"),
                        "value": "BUNGALOW"
                    },
                    {
                        "label": this.$t("chalet"),
                        "value": "CHALET"
                    },
                    {
                        "label": this.$t("castle"),
                        "value": "CASTLE"
                    },
                    {
                        "label": this.$t("farmhouse"),
                        "value": "FARMHOUSE"
                    },
                    {
                        "label": this.$t("country_cottage"),
                        "value": "COUNTRY_COTTAGE"
                    },
                    {
                        "label": this.$t("exceptional_property"),
                        "value": "EXCEPTIONAL_PROPERTY"
                    },
                    {
                        "label": this.$t("apartment_block"),
                        "value": "APARTMENT_BLOCK"
                    },
                    {
                        "label": this.$t("mixed_use_building"),
                        "value": "MIXED_USE_BUILDING"
                    },
                    {
                        "label": this.$t("town_house"),
                        "value": "TOWN_HOUSE"
                    },
                    {
                        "label": this.$t("mansion"),
                        "value": "MANSION"
                    },
                    {
                        "label": this.$t("villa"),
                        "value": "VILLA"
                    },
                    {
                        "label": this.$t("other_property"),
                        "value": "OTHER_PROPERTY"
                    },
                    {
                        "label": this.$t("manor_house"),
                        "value": "MANOR_HOUSE"
                    },
                    {
                        "label": this.$t("pavilion"),
                        "value": "PAVILION"
                    },
                ];
            case "APARTMENT":
                return [
                    {
                        "label": this.$t("apartment"),
                        "value": "APARTMENT"
                    },
                    {
                        "label": this.$t("ground_floor"),
                        "value": "GROUND_FLOOR"
                    },
                    {
                        "label": this.$t("duplex"),
                        "value": "DUPLEX"
                    },
                    {
                        "label": this.$t("triplex"),
                        "value": "TRIPLEX"
                    },
                    {
                        "label": this.$t("flat_studio"),
                        "value": "FLAT_STUDIO"
                    },
                    {
                        "label": this.$t("penthouse"),
                        "value": "PENTHOUSE"
                    },
                    {
                        "label": this.$t("loft"),
                        "value": "LOFT"
                    },
                    {
                        "label": this.$t("kot"),
                        "value": "KOT"
                    },
                    {
                        "label": this.$t("service_flat"),
                        "value": "SERVICE_FLAT"
                    },
                ];
            case "LAND":
                return [
                    {
                        "label": this.$t("land"),
                        "value": "LAND"
                    },
                    {
                        "label": this.$t("building_land"),
                        "value": "BUILDING_LAND"
                    },
                    {
                        "label": this.$t("recreational_area"),
                        "value": "RECREATIONAL_AREA"
                    },
                    {
                        "label": this.$t("forest"),
                        "value": "FOREST"
                    },
                    {
                        "label": this.$t("fields"),
                        "value": "FIELDS"
                    },
                    {
                        "label": this.$t("meadow"),
                        "value": "MEADOW"
                    },
                    {
                        "label": this.$t("orchard"),
                        "value": "ORCHARD"
                    },
                    {
                        "label": this.$t("unbuildable_land"),
                        "value": "UNBUILDABLE_LAND"
                    },
                    {
                        "label": this.$t("agricultural_area"),
                        "value": "AGRICULTURAL_AREA"
                    },
                ];
            case "COMMERCIAL":
            case "BUSINESS":
                return [
                    {
                        "label": this.$t("business"),
                        "value": "BUSINESS"
                    },
                    {
                        "label": this.$t("commercial_premises"),
                        "value": "COMMERCIAL_PREMISES"
                    },
                    {
                        "label": this.$t("mixed_use_building_commercial"),
                        "value": "MIXED_USE_BUILDING_COMMERCIAL"
                    },
                    {
                        "label": this.$t("hotel_restaurant_cafe"),
                        "value": "HOTEL_RESTAURANT_CAFE"
                    },
                ];
            case "OFFICE":
                return [
                    {
                        "label": this.$t("office"),
                        "value": "OFFICES"
                    },
                    {
                        "label": this.$t("building"),
                        "value": "BUILDING"
                    },
                    {
                        "label": this.$t("office_block"),
                        "value": "OFFICE_BLOCK"
                    },
                    {
                        "label": this.$t("mixed_use_building_offices"),
                        "value": "MIXED_USE_BUILDING_OFFICES"
                    },
                    {
                        "label": this.$t("large_town_house"),
                        "value": "LARGE_TOWN_HOUSE"
                    },
                    {
                        "label": this.$t("commercial_villa"),
                        "value": "COMMERCIAL_VILLA"
                    },
                ];
            case "INDUSTRY":
                return [
                    {
                        "label": this.$t("industrial_premises"),
                        "value": "INDUSTRIAL_PREMISES"
                    },
                    {
                        "label": this.$t("mixed_use_building_industries"),
                        "value": "MIXED_USE_BUILDING_INDUSTRIES"
                    },
                    {
                        "label": this.$t("warehouse"),
                        "value": "WAREHOUSE"
                    },
                ];
            case "GARAGE":
                return [
                    {
                        "label": this.$t("outdoor_parking_space"),
                        "value": "OUTDOOR_PARKING_SPACE"
                    },
                    {
                        "label": this.$t("covered_parking_space"),
                        "value": "COVERED_PARKING_SPACE"
                    },
                    {
                        "label": this.$t("lock_up_garage"),
                        "value": "LOCK_UP_GARAGE"
                    },
                    {
                        "label": this.$t("lock_up_parking"),
                        "value": "LOCK_UP_PARKING"
                    },
                ];
            case "OTHER":
                return [
                    {
                        "label": this.$t("other"),
                        "value": "OTHER"
                    },
                    {
                        "label": this.$t("provincial_farmhouse"),
                        "value": "PROVINCIAL_FARMHOUSE"
                    },
                    {
                        "label": this.$t("mill"),
                        "value": "MILL"
                    },
                    {
                        "label": this.$t("bed_n_breakfast"),
                        "value": "BED_N_BREAKFAST"
                    },
                    {
                        "label": this.$t("gites"),
                        "value": "GITES"
                    },
                    {
                        "label": this.$t("static_caravan"),
                        "value": "STATIC_CARAVAN"
                    },
                    {
                        "label": this.$t("mobile_home"),
                        "value": "MOBILE_HOME"
                    },
                    {
                        "label": this.$t("campsite"),
                        "value": "CAMPSITE"
                    },
                    {
                        "label": this.$t("holiday_park"),
                        "value": "HOLIDAY_PARK"
                    },
                    {
                        "label": this.$t("barge"),
                        "value": "BARGE"
                    },
                    {
                        "label": this.$t("hotel"),
                        "value": "HOTEL"
                    },
                    {
                        "label": this.$t("other_house"),
                        "value": "OTHER_HOUSE"
                    },
                    {
                        "label": this.$t("boat_cruise"),
                        "value": "BOAT_CRUISE"
                    },
                ];
            }

            return [];
        },
    },
    watch: {
        propertyType: {
            handler: function(val: string) {
                return val;
            },
            deep: true
        },
    },
    methods: {
        updatePropertySubtype: function(propertySubtype: string): void {
            if (propertySubtype !== "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": propertySubtype});
            } else {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }

            let transactionSubtype: string = this.$store.getters["FormModule/getValue"]("transaction.subtype") || "";
            this.killAndSetValues(this.getPropertyType(), propertySubtype, this.getTransactionType(), transactionSubtype);
        },
        killAndSetValues: async function(propertyType: string, propertySubtype: string, transactionType: string, transactionSubtype: string) {
            killNotRelevantCriteria(propertyType, propertySubtype, transactionType, transactionSubtype);
            addDefaultValuesToStore(propertyType, propertySubtype, transactionType, transactionSubtype);
        }
    }
});

